module.exports = __webpack_public_path__ + "static/media/close.af06b483.svg";